import { render, staticRenderFns } from "./ModalCategoryCompare.vue?vue&type=template&id=72862ed6&scoped=true&"
import script from "./ModalCategoryCompare.vue?vue&type=script&lang=js&"
export * from "./ModalCategoryCompare.vue?vue&type=script&lang=js&"
import style0 from "./ModalCategoryCompare.vue?vue&type=style&index=0&id=72862ed6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72862ed6",
  null
  
)

export default component.exports